import { Fragment, ReactNode, useEffect, useState } from "react";
import { Link } from "react-router";
import { observer } from "mobx-react-lite";

import { faHome } from "@fortawesome/pro-regular-svg-icons";

import { RouteConstants } from "../../../models/enums";
import { IMenuItem } from "../../../models/interfaces";
import { useStore } from "../../../stores/StoreContext";
import { UserProfile } from "../../Core/UserProfile/UserProfile";
import { ActionButton } from "../../Shared/Buttons";
import { LanguageSelection, SidebarToggleButton } from "../../Shared/Components";
import { CurrentUserBudgetInfo } from "../../Shared/Components/CurrentUserBudgetInfo/CurrentUserBudgetInfo";
import { NavbarDivider } from "../../Shared/Components/NavbarDivider/NavbarDivider";

import "./Navbar.scss";

interface INavbarElement {
  id: string;
  element: ReactNode;
}

const NavbarComponentRaw = () => {
  const { navigationStore, sidebarStore, breakpointStore, userStore } = useStore();
  const [menuItem, setMenuItem] = useState<IMenuItem>();
  const [isNavigationVisible, setIsNavigationVisible] = useState(false);

  const [navbarRightElements, setNavbarRightElements] = useState<INavbarElement[]>([]);

  useEffect(() => {
    setMenuItem(navigationStore.currentActiveMenuItem);
  }, [navigationStore.currentActiveMenuItem]);

  useEffect(() => {
    setIsNavigationVisible(
      sidebarStore.isOverlaySidebar(breakpointStore.device) &&
        navigationStore.currentActiveMenuItem?.path !== RouteConstants.LandingPage,
    );
  }, [breakpointStore.device, navigationStore.currentActiveMenuItem]);

  useEffect(() => {
    setNavbarRightElements([
      {
        id: "budget-info",
        element: <CurrentUserBudgetInfo />,
      },
      { id: "language-selection", element: <LanguageSelection /> },
    ]);
  }, [userStore.userAcceptedTermsOfUseAndPrivacyPolicy, userStore.currentLanguage]);

  return (
    <div className="navbar">
      <div className="left-area">
        {!!isNavigationVisible && (
          <div className="navbar-navigation-container">
            {sidebarStore.isOverlaySidebar(breakpointStore.device) && (
              <SidebarToggleButton onClick={() => sidebarStore.setOverlaySidebarVisible(true)} />
            )}

            {navigationStore.currentActiveMenuItem?.path !== RouteConstants.LandingPage &&
              sidebarStore.isOverlaySidebar(breakpointStore.device) && (
                <div className="sidebar-home-navigation">
                  <Link to={RouteConstants.LandingPage}>
                    <ActionButton id="home-button" icon={faHome} showBackground />
                  </Link>
                </div>
              )}
          </div>
        )}

        {!!menuItem?.navbarItem && (
          <div className="navbar-feature-container">
            <menuItem.navbarItem />
          </div>
        )}
      </div>

      <div className="right-area">
        {navbarRightElements.map((navbarElement, index) => (
          <Fragment key={navbarElement.id}>
            {navbarElement.element}

            {index < navbarRightElements.length - 1 && <NavbarDivider />}
          </Fragment>
        ))}

        <UserProfile />
      </div>
    </div>
  );
};

export const NavbarComponent = observer(NavbarComponentRaw);
